import { Routes } from '@angular/router';
import { FooterResolver } from 'footer';
import { MainNavigationResolver } from 'navigation';
import { App } from 'utils';
import { ExternalUrlsGuard } from '../route-guards/external-urls.guard';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingPagesGuard } from './landing-pages.guard';
import { LandingPageResolve } from './resolvers/landing-page.resolve';
import { LandingPageRedirectGuard } from './route-guards/landing-page-redirect.guard';
import { LandingPageContainerComponent } from './skeleton/landing-page-container/landing-page-container.component';

const childrenRoutes: Routes = [
  {
    path: '**',
    component: LandingPageComponent,
    resolve: { cmsData: LandingPageResolve, app: () => App.website },
    canActivate: [ExternalUrlsGuard, LandingPageRedirectGuard],
    canDeactivate: [LandingPagesGuard],
  },
];

export const routes: Routes = [
  {
    path: '',
    component: LandingPageContainerComponent,
    children: childrenRoutes,
    resolve: { mainNavigation: MainNavigationResolver, footer: FooterResolver },
  },
];
